import { render } from "./MuseoComponent.vue?vue&type=template&id=7908f82e&scoped=true"
import script from "./MuseoComponent.vue?vue&type=script&lang=js"
export * from "./MuseoComponent.vue?vue&type=script&lang=js"

import "./MuseoComponent.vue?vue&type=style&index=0&id=7908f82e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\anton\\Desktop\\cangas_de_narcea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7908f82e"]])

export default __exports__